/**
 * A utility method that grabs the desired fields from the URL parameters and
 * returns an object with the available fields.
 * @param field URL Parameters to extract
 * @returns Object containing found parameters
 */
function extractFieldsFromURLParams(fields: string[]) {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  const payload: Record<string, string> = {};
  fields.forEach((parameter) => {
    const value = searchParams.get(parameter);
    if (value) payload[parameter] = value;
  });
  return payload;
}

/**
 * Get the email and name fields from url parameters.
 */
export function getEmailAndNameFromURLParams() {
  return extractFieldsFromURLParams(["email", "name"]);
}

/**
 * Get all url parameters.
 * NOTE(Patrick): This implementation uses the last key in the search string if
 * a key shows up more than once. While not ideal, this is the implementation used
 * by Conversion Tracker. If you need an implementation that supports search params
 * that appear more than once, please see
 * https://stackoverflow.com/questions/8648892/how-to-convert-url-parameters-to-a-javascript-object.
 */
export function getURLParams() {
  const params = new URLSearchParams(window.location.search);
  const urlParams = {};
  params.forEach((value, key) => {
    urlParams[key] = value;
  });
  return urlParams;
}

export default extractFieldsFromURLParams;
